/**
 * Feature flags – flip these to show/hide features without deleting code.
 */

/** When false the Screener page, sidebar link, and "Open in Screener" actions are hidden. */
export const FEATURE_SCREENER_ENABLED = true

/** Temporarily hide screener trade panels and hover volume; preserve stored layouts. */
export const FEATURE_SCREENER_TRADES_ENABLED = false
